import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("op_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["Accept-Language"] = localStorage.getItem("op_lang") || "it";
  // Accept-Language è un header vietato nel browser: usiamo il nostro.
  config.headers["X-App-Lang"] = localStorage.getItem("op_lang") || "it";
  return config;
});

export function apiError(detail) {
  const generic =
    locale === "en"
      ? "Something went wrong. Please try again."
      : "Qualcosa è andato storto. Riprova.";
  if (detail == null) return generic;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return locale === "en"
      ? "Please check the details you entered."
      : "Controlla i dati inseriti.";
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail[locale] === "string") return detail[locale];
  return generic;
}

let locale = localStorage.getItem("op_lang") || "it";
let userCurrency = localStorage.getItem("op_currency") || "EUR";

export const setLocale = (lang) => {
  locale = lang;
};

export const setCurrency = (code) => {
  userCurrency = code || "EUR";
  localStorage.setItem("op_currency", userCurrency);
};

export const getCurrency = () => userCurrency;

export const getLocale = () => locale;

const intlLocale = () => (locale === "en" ? "en-GB" : "it-IT");

export const money = (n, currency) =>
  new Intl.NumberFormat(intlLocale(), {
    style: "currency",
    currency: currency || userCurrency,
    currencyDisplay: "narrowSymbol",
  }).format(Number(n || 0));

export const eur = (n) => money(n);

export const dateIt = (s) => (s ? new Date(s).toLocaleDateString(intlLocale()) : "—");

export const dateLong = (s) =>
  s
    ? new Date(s).toLocaleDateString(intlLocale(), {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : "—";

export const dateTimeIt = (s) =>
  s
    ? new Date(s).toLocaleString(intlLocale(), {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "—";

export default api;
